import VueRouter from 'vue-router';

import Step1 from '../components/Step1';
import Step2 from '../components/Step2';
import Step3 from '../components/Step3';
import Step4 from '../components/Step4';
import Step5 from '../components/Step5';

export default function createRouter() {

    var routes = [];

    routes.push({
        path: '/step1',
        component: Step1
    });

    routes.push({
        path: '/step2',
        component: Step2
    });

    routes.push({
        path: '/step3',
        component: Step3
    });

    routes.push({
        path: '/step4',
        component: Step4
    });

    routes.push({
        path: '/step5',
        component: Step5
    });

    var router = new VueRouter({
        mode: 'abstract',
        fallback: false, //no backwards compatibility for old browsers
        routes: routes,
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                return { x: 0, y: 0 }
            }
        }
    });

    return router;
}